import styled from 'styled-components';

export const WidgetTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: -2px 0;
`;
